import React from 'react'
import './styles.scss'

interface Props {
  list: Array<string>
}

export const MiniScrollList = ({ list }: Props) => {
  return (
    <div className='miniScrollList'>
      <div>
        <i className='ui chevron up icon' />
      </div>
      <div className='content'>
        <ul>
          {list.map((item, i) => (
            <li key={`miniScrollList-${i}`}>{item}</li>
          ))}
        </ul>
      </div>
      <div>
        <i className='ui chevron down icon' />
      </div>
    </div>
  )
}
